//importing style
import 'react-phone-input-2/lib/style.css';
import "./styles/styles.scss";

//importing react components
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './tests/reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment-timezone';
//importing context providers
import {AppDataProvider} from "./context/data";
import {AppStateProvider} from "./context/state";


//importing components
import App from "./App";
import {LocalizationProvider} from "@mui/x-date-pickers";

moment.tz.setDefault('Europe/Oslo');
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <LocalizationProvider dateAdapter={AdapterMoment}>
    <AppStateProvider>
      <AppDataProvider>
        {/*Router container for website redirects*/}
        <BrowserRouter>
          {/*Application render*/}
          <App/>
        </BrowserRouter>
      </AppDataProvider>
    </AppStateProvider>
  </LocalizationProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
